import { Button, Link, Paper, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { MARINER_SUPPORT_EMAIL } from "../../common/MarinerSupportEmail";
import logo from "../.././images/ts-logo-nobg.png";
import "./SignUp.scss";

const Landing = () => {

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(MARINER_SUPPORT_EMAIL);
    toast.success(<p>Copied to clipboard successfully.</p>, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  return (
    <div className="landing-sign">
      <Paper className="flex-gap">
        <img className="logo-size" src={logo} alt="tote services logo" />
        <div className="flex-gap">
          <p className="landing-txt">Welcome!</p>
          <div className="flex-btn">
            <Button
              variant="contained"
              className="blue-button sign-up-btn"
              type="button"
              onClick={() =>
                window.location.replace(
                  `${process.env.REACT_APP_COGNITO_DOMAIN}login?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${process.env.REACT_APP_COGNITO_REDIRECT_URI}`
                )
              }
            >
              Log in
            </Button>
          </div>
        </div>

        <div className="help-actions">
          <span>
            <p>
              Questions regarding this system? Contact
              <Tooltip title="Copy Address to Clipboard" placement="top">
                <Link
                  className="blue-link"
                  onClick={() => handleCopyToClipboard()}
                >
                  {MARINER_SUPPORT_EMAIL}
                </Link>
              </Tooltip>
            </p>
          </span>
        </div>
      </Paper>
    </div>
  );
};

export default Landing;
